export default __webpack_public_path__ + "static/media/shipping.3fcf1db9.png";